/* eslint-disable prettier/prettier */

import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import TableData from "./data/DataTableMaterial";
import toast, { Toaster } from "react-hot-toast";
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDSnackbar from "components/MDSnackbar";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import { getAllIntentosSolicitud } from "store/solicitudes/solicitudesActions";

import Loading from "../../components/loading";
import moment from "moment";

function IntentosDeSolicitud() {
  const { intentosDeSolicitud, isloadingIntentoSolicitud } = useSelector(
    (state) => state.solicitud
  );

  const dispatch = useDispatch();

  // Carga inicial al montar el componente
  useEffect(() => {
    getAllIntentosSolicitud(dispatch);
  }, []);

  const columnsSolicitudes = useMemo(
    () => [
      {
        accessorKey: "precandidato", //access nested data with dot notation
        header: "Precandidato",
      },
      {
        accessorKey: "llena",
        header: "Solicitante",
      },
      {
        accessorKey: "fechaAplicacion", //normal accessorKey
        header: "Fecha de aplicacion",
        Cell: ({ row }) => {
          return moment(row.original.fechaAplicacion).format("DD/MM/YYYY");
        },
      },
      {
        accessorKey: "fechaNacimiento",
        header: "Fecha de nacimiento",
        size: 100,
        Cell: ({ row }) => {
          return moment(row.original.fechaNacimiento).format("DD/MM/YYYY");
        },
      },
      {
        accessorKey: "correoContacto",
        header: "Correo",
      },

      {
        accessorKey: "motivo",
        header: "Motivo",
      },
    ],
    []
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="primary"
                borderRadius="lg"
                coloredShadow="primary"
                style={{ paddingTop: 10 }}
              >
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6} lg={6}>
                    <MDTypography variant="h6" color="white">
                      Intentos de solicitud
                    </MDTypography>
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <MDBox textAlign="right"></MDBox>
                  </Grid>
                </Grid>
              </MDBox>
              <MDBox pt={3}>
                {isloadingIntentoSolicitud ? (
                  <Loading title={"Procesando por favor espere"} />
                ) : (
                  <TableData
                    columns={columnsSolicitudes}
                    data={intentosDeSolicitud}
                    showModal={() => {}}
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Toaster
        toastOptions={{ style: { backgroundColor: "#5873B8", fontSize: 12, color: "white" } }}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default IntentosDeSolicitud;
